// import { useEffect, useState } from "react";
// import websocketClient from "../utils/websocketClient";

// const useMessageList = () => {
//   const token = localStorage.getItem("access_token");
//   const [conversations, setConversations] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [unreadMap, setUnreadMap] = useState({});
//   const BASE_URL = process.env.REACT_APP_BASE_URL;
//   const CLIENT_URL =process.env.REACT_APP_CLIENT_BASE_URL
//   console.log("The conversations are:",conversations)
//   const WS_URL = process.env.REACT_APP_WS_BASE_URL;

//   useEffect(() => {
//     if (!token) return;

//     const socketName = "messages-list";
//     const url = `${WS_URL}/ws/messages_list/`;
    
//     websocketClient.connect(socketName, url, token);

//     // const handleMessage = (data) => {
//     //   if (data.results) {
//     //     setConversations(data.results);

//     //     const unreadByUser = data.results.reduce((acc, msg) => {
//     //       if (msg.message_by === "friend" && !msg.is_read) {
//     //         const uid = msg.user_profile.id;
//     //         acc[uid] = (acc[uid] || 0) + 1;
//     //       }
//     //       return acc;
//     //     }, {});

//     //     setUnreadCount(data.total_unread_messages);

//     //     setUnreadMap(unreadByUser);
//     //   }
//     // };
//     const handleMessage = (data) => {
//       if (data.results) {
//         const sanitized = data.results.filter(
//           (conv) => conv.message && conv.message.trim() !== ""
//         );

//         setConversations(sanitized);

//         const unreadByUser = sanitized.reduce((acc, msg) => {
//           if (msg.message_by === "friend" && !msg.is_read) {
//             const uid = msg.user_profile.id;
//             acc[uid] = (acc[uid] || 0) + 1;
//           }
//           return acc;
//         }, {});

//         setUnreadCount(data.total_unread_messages);
//         setUnreadMap(unreadByUser);
//       }
//     };

//     websocketClient.subscribe(socketName, handleMessage);

//     return () => {
//       websocketClient.unsubscribe(socketName, handleMessage);
//       websocketClient.disconnect(socketName);
//     };
//   }, [token]);

//   const markConversationRead = (friendId) => {
//     setConversations((prev) =>
//       prev.map((conv) =>
//         conv.user_profile.id === friendId ? { ...conv, is_read: true } : conv
//       )
//     );
//     setUnreadCount((prev) => Math.max(0, prev - 1));
//   };

//   return {
//     conversations,
//     unreadCount,
//     markConversationRead,
//     unreadMap,
//     setConversations,
//   };
// };

// export default useMessageList;
import { useEffect, useState } from "react";
import websocketClient from "../utils/websocketClient";

const useMessageList = () => {
  const token = localStorage.getItem("access_token");
  const [conversations, setConversations] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadMap, setUnreadMap] = useState({});
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const CLIENT_URL =process.env.REACT_APP_CLIENT_BASE_URL
  // console.log("The conversations are:",conversations)
  const WS_URL = process.env.REACT_APP_WS_BASE_URL;

  useEffect(() => {
    if (!token) return;

    const socketName = "messages-list";
    const url = `${WS_URL}/ws/messages_list/`;
    
    websocketClient.connect(socketName, url, token);

    // const handleMessage = (data) => {
    //   if (data.results) {
    //     setConversations(data.results);

    //     const unreadByUser = data.results.reduce((acc, msg) => {
    //       if (msg.message_by === "friend" && !msg.is_read) {
    //         const uid = msg.user_profile.id;
    //         acc[uid] = (acc[uid] || 0) + 1;
    //       }
    //       return acc;
    //     }, {});

    //     setUnreadCount(data.total_unread_messages);

    //     setUnreadMap(unreadByUser);
    //   }
    // };
    const handleMessage = (data) => {
      if (data.results) {
        const sanitized = data.results.filter(
          (conv) => conv.message && conv.message.trim() !== ""
        );

        setConversations(sanitized);

        const unreadByUser = sanitized.reduce((acc, msg) => {
          if (msg.message_by === "friend" && !msg.is_read && msg.user_profile) {
            const uid = msg.user_profile.id;
            acc[uid] = (acc[uid] || 0) + 1;
          }
          return acc;
        }, {});

        setUnreadCount(data.total_unread_messages);
        setUnreadMap(unreadByUser);
      }
    };

    websocketClient.subscribe(socketName, handleMessage);

    return () => {
      websocketClient.unsubscribe(socketName, handleMessage);
      websocketClient.disconnect(socketName);
    };
  }, [token]);

  const markConversationRead = (friendId) => {
    setConversations((prev) =>
      prev.map((conv) =>
        conv.user_profile?.id === friendId ? { ...conv, is_read: true } : conv
      )
    );
    setUnreadCount((prev) => Math.max(0, prev - 1));
  };

  return {
    conversations,
    unreadCount,
    markConversationRead,
    unreadMap,
    setConversations,
  };
};

export default useMessageList;
